import classNames from 'classnames';
import { useState } from 'react';
import { Card, Features, Footer, Hero, Logos, MobileHeader, Profile, Start } from '../components';
import { AuthSkeleton } from '../layout';

const Login = () => {
  const [success, setSucces] = useState(false);
  const _handleLogin = () => {
    // TODO: network logic
    setSucces(true);
  };
  return (
    <>
      <MobileHeader
        actions={
          <>
            <a>Don't have an account?</a>
            <a href='/register' className='primary bg-gradient rounded-full'>
              Register
            </a>
          </>
        }
      />
      <AuthSkeleton>
        <Card
          className={classNames('login', success && 'success')}
          title={`Hey! You're back!`}
          subtitle='Could you add more text here that  user easily understand!'
          action='Login'
          onClick={_handleLogin}
        />
      </AuthSkeleton>
    </>
  );
};
export default Login;
